import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ArrowLeft, Languages } from "lucide-react";
import Logo from "@/components/Logo";
import PinPad from "@/components/PinPad";

export default function StaffLogin() {
    const { t, lang, setLang, pinLogin } = useApp();
    const navigate = useNavigate();
    const [pin, setPin] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (val) => {
        if (loading) return;
        setLoading(true);
        try {
            const u = await pinLogin(val);
            toast.success(t("welcome_back") + ", " + u.name);
            const dest = {
                manager: "/dashboard",
                cashier: "/cashier",
                waiter: "/waiter",
                kitchen: "/kitchen",
                driver: "/driver",
            }[u.role] || "/";
            navigate(dest);
        } catch (err) {
            toast.error(err.response?.data?.detail || t("wrong_pin"));
            setPin("");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen coffee-bg flex flex-col">
            <header className="flex items-center justify-between p-5">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground" data-testid="back-home">
                    <ArrowLeft className="h-4 w-4 flip-rtl" />{t("back")}
                </Link>
                <Button variant="ghost" size="sm" onClick={() => setLang(lang === "ar" ? "en" : "ar")} className="gap-2" data-testid="staff-lang-toggle">
                    <Languages className="h-4 w-4" />{t("switch_lang")}
                </Button>
            </header>

            <div className="flex-1 flex items-center justify-center p-6">
                <div className="w-full max-w-md rounded-2xl border border-border bg-card/70 backdrop-blur-sm p-8 grain" data-testid="staff-login-card">
                    <div className="flex justify-center mb-4">
                        <Logo size={56} />
                    </div>
                    <div className="text-center mb-8">
                        <h1 className={`${lang === "ar" ? "font-ar" : "font-display-en italic"} text-3xl mb-2`}>{t("staff_login")}</h1>
                        <p className="text-sm text-muted-foreground">{t("enter_pin")}</p>
                    </div>
                    <PinPad value={pin} onChange={setPin} onSubmit={submit} />
                    <div className="text-center pt-6">
                        <Link to="/login" className="text-xs text-muted-foreground hover:text-primary" data-testid="goto-owner-login">
                            {t("owner_login")} →
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
